import { createContext, useContext } from 'react'
import { type ScheduleDateFiledStore } from '../store/ScheduleDateFiledStore'

export const ScheduleDateFiledContext = createContext<ScheduleDateFiledStore | null>(null)

export const useScheduleDateFiledContext = () => {
  const context = useContext(ScheduleDateFiledContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ScheduleDateFiledContext')

  return context
}
